import { useMemo } from 'react';
import moment from 'moment-timezone';

import { Campaign, CampaignChangeRequest } from '../../../types/Campaign';
import { useCampaignChangeGracePeriod } from './CampaignChangeGracePeriod';

interface UseProps {
    campaign: Campaign;
    campaignChangeRequest: CampaignChangeRequest | null;
}

interface UseState {
    isCampaignChangeable: boolean;
}

const campaignDeliveryStatuses: string[] = ['PENDING_COGNITION'];

const useCampaignChange = ({ campaign, campaignChangeRequest }: UseProps): UseState => {
    const { hasCampaignChangeGracePeriodExpired } = useCampaignChangeGracePeriod({ campaign });

    const isCampaignChangeable = useMemo((): boolean => {
        if (campaign.dspCampaignRefreshedDate) {
            // Check if the refresh date is not stale for 30 minutes ago.
            return moment(campaign.dspCampaignRefreshedDate).isBefore(moment().subtract(30, 'minutes'));
        }

        if (campaignChangeRequest !== null && campaignChangeRequest.status === 'Pending') {
            return false;
        }

        if (campaign !== null && campaignDeliveryStatuses.includes(campaign.deliveryStatusId)) {
            return false;
        }

        if (hasCampaignChangeGracePeriodExpired) {
            return false;
        }

        return true;
    }, [campaign, campaignChangeRequest, hasCampaignChangeGracePeriodExpired]);

    return {
        isCampaignChangeable,
    };
};

export type { UseProps as UseCampaignChangeProps };
export type { UseState as UseCampaignChangeState };
export { useCampaignChange };
